import { Shield, Award, Zap, Users } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Shield className="text-toxic-orange" size={40} />,
      title: 'Trusted Reviews',
      description: 'Every casino we feature has been thoroughly vetted for licensing, security, and player protection standards.'
    },
    {
      icon: <Award className="text-toxic-orange" size={40} />,
      title: 'Exclusive Deals',
      description: 'We negotiate special bonuses and promotions you won\'t find anywhere else. More value, less hassle.'
    },
    {
      icon: <Zap className="text-toxic-orange" size={40} />,
      title: 'Fast Payouts',
      description: 'We prioritize casinos that process withdrawals quickly. Your winnings should reach you fast, not sit in limbo.'
    },
    {
      icon: <Users className="text-toxic-orange" size={40} />,
      title: 'Player-First Approach',
      description: 'Our recommendations are based on what actually matters: game quality, customer service, and fair play.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-dark-black to-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Why Empire Wager?
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed">
              The UK online casino market is crowded. Every operator claims to be the best, but most fall short where it counts. We cut through the noise and show you casinos that actually deliver on their promises.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-gray-900/50 border border-gray-800 rounded-lg p-6 hover:border-toxic-orange transition-colors"
              >
                <div className="mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-white mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-toxic-orange/10 to-transparent border-l-4 border-toxic-orange p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-white mb-4">
              Our Mission
            </h3>
            <p className="text-gray-300 leading-relaxed">
              We're not here to push you toward any particular casino. Our job is to give you the information you need to make smart choices. Whether you're after massive jackpots, live dealer action, or casual slot sessions, we'll point you toward operators that match your style and budget. No fluff, no false promises—just honest insights from people who understand the industry inside and out.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

